import {  Router } from "@angular/router";
import CoreApplication from "@core/r2";
import { environment } from "@env";
import { IAuthCallbackParams } from "@listat/r2-core";
import { SessionBase } from "@core/base/session-base";
import { logger } from "@services/logger/logger.service";
import { ICoreDependencies } from "@core/core-boot/core-boot.types";

export class WebSession extends SessionBase implements SessionBase {
    private r2Core: typeof CoreApplication;
    private router: Router;

    constructor(
        protected dependencies: ICoreDependencies,
    ) {
        super();
        this.r2Core = CoreApplication;
        this.r2Core.auth.setOptions(
            {
                redirectUri: `${location.origin}${environment.redirect_path_name}`,
            }
        );
        this.router = dependencies.router;
    }

    public async check(): Promise<boolean> {
        try {
            const state = await this.r2Core.auth.checkSession();

            const userInfo = await this.r2Core.user.getInfo();
            this.sessionInfo.user_email = userInfo?.email;
            this.sessionInfo.user_hint = userInfo?.email;

            this.authState$.next(Boolean(state));
            this._sessionInfo$.next(this.sessionInfo);

            return Boolean(state);
        } catch (error) {
            logger.error(error);
            return false;
        }
    }

    public async processCallback() {
        const callbackParams = <IAuthCallbackParams>this.dependencies.routerInfo.snapshot.queryParams;
        const hasCallbackParams = callbackParams?.code && callbackParams?.state;

        if (hasCallbackParams) {
            try {
                await this.r2Core.auth.processCallback(callbackParams);
            } catch (e) {
                logger.error(e);
            }

            return true;
        }

        return false;
    }

    public async logout(): Promise<void> {
        try {
            await this.r2Core.auth.logout();
        } catch (e) {
            logger.error(e);
        }

        this.authState$.next(false);
        delete this.sessionInfo.user_email;
        this._sessionInfo$.next(this.sessionInfo);
        await this.router.navigate(["/"]);
    }

    public async login(): Promise<string> {
        const authOptionsDefault = {
            prompt: 'login',
        }

        return await this.r2Core.auth.getAuthLink(authOptionsDefault);
    }
}
